export default __webpack_public_path__ + "static/exp5-ad2c23909557a72e2cc552f3a127b311.png";